import { Capacitor } from '@capacitor/core'
import { getWrapperRole } from '../utils/wrapperRole'
import type { LogPlatform } from '../types/telemetry'

export const getPlatform = (): LogPlatform => {
  if (typeof window === 'undefined') return 'server'
  if (Capacitor.isNativePlatform()) {
    const platform = Capacitor.getPlatform()
    if (platform === 'ios') return 'capacitor-ios'
    if (platform === 'android') return 'capacitor-android'
  }
  const wrapperRole = getWrapperRole()
  if (wrapperRole === 'helper') return 'helper-web'
  if (wrapperRole === 'member') return 'member-web'
  return 'web'
}
